<template>
    <div class="pic-gallery">
        <v-container>
            <v-layout row wrap>
                <v-flex xs12 sm3 v-for="(pic, index) in pix" :key="index">
                    <a data-fancybox="pix" data-type="image" :href="`/img/gallery/${pic}`">
                        <div class="thumb mr-1 mb-1">
                            <v-img :src="`/img/gallery/${pic}`" alt="Образец работы"></v-img>              
                        </div>
                    </a>
                </v-flex>
            </v-layout>         
        </v-container>
    </div>
</template>

<script>
    export default {
      name: 'PicGallery',
      data() {
          return {
               pix: [
                  '1.png', '2.png', '3.png', '4.png', '5.png', '6.png', '8.png', '9.png', '10.png', '11.png', '12.png', '13.png', '14.png', '15.png', '16.png', '17.png', '18.png', '19.png', '20.png', '21.png', '22.png', '23.png', '24.png', '25.png', '26.png', '27.png', '28.png', '29.png'
               ]
            }
        }
    }
</script>

